import { useState, useCallback } from 'react';
import { getNotifications, markAllAsRead as apiMarkAllAsRead } from '@/api/notifications';
import { Notification } from '@/types/notifications';

// Define the filter interface for the hook
interface NotificationFilters {
  type?: string;
  limit?: number;
  page?: number;
  tenantId?: number;
}

interface NotificationsResponse {
  notifications: Notification[];
  total: number;
}

export const useNotifications = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchNotifications = useCallback(
    async (filters: NotificationFilters): Promise<NotificationsResponse | null> => {
      setLoading(true);
      setError(null);
      try {
        const response = await getNotifications(filters);
        return response;
      } catch (err: any) {
        setError(err.message || 'Failed to fetch notifications');
        return null;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const markAllAsRead = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      await apiMarkAllAsRead();
      return true;
    } catch (err: any) {
      setError(err.message || 'Failed to mark notifications as read');
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    fetchNotifications,
    markAllAsRead,
  };
};
